import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { inviteSchema, type InviteInput } from '../routes/members.schema';

export function InviteMemberDialog(p: { open: boolean; onClose: () => void; onSubmit: (d: InviteInput) => void }) {
  const { register, handleSubmit, formState: { errors } } = useForm<InviteInput>({ resolver: zodResolver(inviteSchema) });
  if (!p.open) return null;
  return (
    <div role="dialog" aria-modal="true" className="fixed inset-0 bg-black/40 flex items-center justify-center">
      <form onSubmit={handleSubmit(p.onSubmit)} className="bg-white rounded p-6 w-96 space-y-3">
        <h2 className="text-lg font-bold text-primary">Invite member</h2>
        <label className="block">Email<input {...register('email')} className="mt-1 w-full border rounded p-2" /></label>
        {errors.email && <p className="text-sm text-accent">{errors.email.message}</p>}
        <label className="block">Role<select {...register('role')} className="mt-1 w-full border rounded p-2">
          <option value="admin">Admin</option><option value="manager">Manager</option>
        </select></label>
        <div className="flex gap-2 justify-end">
          <button type="button" onClick={p.onClose}>Cancel</button>
          <button type="submit" className="rounded bg-primary px-4 py-2 text-white">Send invite</button>
        </div>
      </form>
    </div>
  );
}
